module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noPriceLines":"There are no pricelines yet."},"no":{"noPriceLines":"Det er ingen prislinjer ennå."}}')
  delete Component.options._Ctor
}
